<template>
  <Dialog
    v-model="dialog"
    icon="fas fa-plus"
    :title="'新出語彙登録'"
    colorTextYes="red--text"
    :width="500"
  >
    <template v-slot:content>
      <v-row class="px-4" v-for="lang in language" :key="lang.key">
        <v-textarea
          :spellcheck="false"
          dense
          :auto-grow="true"
          outlined
          :rows="2"
          v-model="name[lang.key]"
          :error-messages="nameErrors"
          @input="$v.name.ja.$touch()"
          @blur="$v.name.ja.$touch()"
          v-if="lang.key == 'ja'"
        >
          <template v-slot:label>
            <span class="font-weight-bold mr-1">{{ lang.text }}</span>
            <span class="red--text" v-if="lang.key == 'ja'">*</span>
          </template>
        </v-textarea>
        <v-textarea
          :spellcheck="false"
          dense
          :auto-grow="true"
          outlined
          :rows="2"
          v-model="name[lang.key]"
          v-else
        >
          <template v-slot:label>
            <span class="font-weight-bold mr-1">{{ lang.text }}</span>
          </template>
        </v-textarea>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-btn
        color="primary"
        small
        :loading="loading"
        @click="createVocabulary"
        :disabled="loading"
        >{{ $t("REGISTER") }}</v-btn
      >
      <v-btn color @click="dialog = false" small>キャンセル</v-btn>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "@/components/Dialog/Dialog";
import { createVocabularyForConversation } from "@/api/Vocabulary.api";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  props: ["item"],
  components: { Dialog },
  mixins: [validationMixin],
  data() {
    return {
      dialog: false,
      loading: false,
      language: [
        { text: "日本語", key: "ja" },
        { text: "英語", key: "en" },
        { text: "中国語", key: "cn" },
        { text: "ベトナム語", key: "vn" },
        { text: "ベンガル語", key: "bn" },
        { text: "ポルトガル語", key: "pt" },
      ],
      name: { ja: "", en: "", cn: "", vn: "", bn: "", pt: "" },
    };
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.name.ja.$dirty) return errors;
      !this.$v.name.ja.required && errors.push("日本語を入力してください。");
      return errors;
    },
  },
  validations() {
    return {
      name: {
        ja: {
          required,
        },
      },
    };
  },
  watch: {
    dialog: function () {
      this.$v.$reset();
      this.name = { ja: "", en: "", cn: "", vn: "", bn: "", pt: "" };
    },
  },
  methods: {
    async createVocabulary() {
      const { name } = this;
      this.$v.$touch();
      if (!this.$v.$anyError) {
        this.loading = true;
        let params = {
          name,
          conversation: this.$route.params.skit,
        };
        await createVocabularyForConversation(params)
          .then(() => {
            this.$emit("resetList");
            this.dialog = false;
          })
          .catch(() => (this.loading = false));
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>